export function createExporterObj(token: any): any {
  return JSON.parse(JSON.stringify(token));
}
